export default __webpack_public_path__ + "tmp_src/components/Accordion/Accordion~nova.css.liquid";